import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '@shared/services/core/config.service';
import { ManifestsRepository } from '@shared/state/manifests';

@Pipe({
	name: 'qrProductCode',
})
export class QRProductCodePipe implements PipeTransform {
	constructor(private readonly env: ConfigService,
		private readonly manifestRepo: ManifestsRepository) {}

	transform(productId: number, ...args: any[]): string {
		if (!args || args.length === 0) return '';
		const { reservation_id } = args[0];
		let manifestUrl = (this.env.get('manifestUrl') as string).replace('$reservationId', reservation_id.toString());
		if (productId && productId > 0) {
			const manifestId = this.manifestRepo.getActiveManifest().id;
			const workflow = 'GUIDED_WORKFLOW';
			manifestUrl = `${manifestUrl}/${manifestId}/product/${productId}/guest/create?activeProduct=${productId}&workflow=${workflow}`;

		} else {
			manifestUrl = `${manifestUrl}/product-list`;
		}
		return manifestUrl;
	}
}
